export const TRACKING_DETAILS_FRAGMENT = `{
  clickUrl
  dismissUrl
  impressionUrl
  presentmentUrl
}`
